import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import {
  SeHouseholdSetupFeatureMinorAccountInviteModule
} from '@se-po/se-household-setup-feature-minor-account-invite'
import { SharedUiEmailModule } from '@se-po/shared-ui-email'
import { SharedUiSetupBarModule } from '@se-po/shared-ui-setup-bar'
import { SeFeBannerModule } from 'se-fe-banner'
import { SeFeCardModule } from 'se-fe-card'
import {
  SeFeIconModule,
  seFeIconCopy,
  seFeIconDownload,
  seFeIconPrint,
  seFeIconSpotId,
  seFeIconSpotSafety,
  seFeIconSpotWhistle
} from 'se-fe-icon'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFeSpinnerModule } from 'se-fe-spinner'

import { MinorAccountRoutingModule } from './minor-account-routing.module'
import { MinorAccountComponent } from './minor-account.component'

@NgModule({
  declarations: [
    MinorAccountComponent,
  ],
  imports: [
    CommonModule,
    MinorAccountRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeBannerModule,
    SeFeCardModule,
    SeFeIconModule.include([
      seFeIconCopy,
      seFeIconDownload,
      seFeIconPrint,
      seFeIconSpotId,
      seFeIconSpotSafety,
      seFeIconSpotWhistle
    ]),
    SeFeLinkModule,
    SeFeSpinnerModule,
    SeHouseholdSetupFeatureMinorAccountInviteModule,
    SharedUiEmailModule,
    SharedUiSetupBarModule,
  ],
  exports: [],
  providers: []
})
export class MinorAccountModule { }
